import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import { Box, Flex, IconButton, Link, Popover, PopoverContent, PopoverTrigger as OrigPopoverTrigger, Text, Button, Stack, Collapse, Icon, useColorModeValue, useDisclosure, Container, useColorMode, Menu, MenuButton, MenuList, Center, Avatar, MenuDivider, MenuItem, Spacer, Drawer, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Image } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import AuthUtil from "utils/auth-utils";
import { useLocation, useNavigate } from "react-router-dom";
import AppConsts from "libs/appconst";

export const PopoverTrigger: React.FC<{ children: React.ReactNode }> =
    OrigPopoverTrigger

type LayoutProps = {
    children: ReactNode
};

const WithSubnavigation = () => {
    const navigate = useNavigate();
    const { isOpen, onToggle } = useDisclosure();
    //const { isOpen, onOpen, onClose } = useDisclosure();
    const [user, setUser] = useState<any>(null);

    useEffect(() => {
        var currentUser = AuthUtil.GetCurrentUser();
        setUser(currentUser);
    }, []);

    return (
        <Box>
            <Flex
                bg={useColorModeValue('white', 'gray.800')}
                color={useColorModeValue('gray.600', 'white')}
                minH={'60px'}
                py={{ base: 2 }}
                px={{ base: 4 }}
                align={'center'}>

                <Flex flex={{ base: 2 }} justify={{ base: 'left', md: 'start' }}>
                    <Link onClick={() => { window.location.href = "/" }}>
                        <Image src={process.env.PUBLIC_URL + AppConsts.LOGO_PATH} h={'30px'} />
                    </Link>
                    <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
                        <DesktopNav user={user} />
                    </Flex>
                </Flex>
                <Spacer />
                <Stack
                    display={{ base: 'none', md: 'flex', sm: 'none' }}
                    flex={{ base: 1, md: 0 }}
                    justify={'flex-end'}
                    direction={'row'}
                    spacing={6}>
                    <Menu placement={"bottom-end"}>
                        <MenuButton
                            as={Button}
                            rounded={'full'}
                            variant={'link'}
                            cursor={'pointer'}
                            minW={0}>
                            <Avatar
                                size={'sm'}
                                src={user?.profilePictureFullUrl || ''}
                            />
                        </MenuButton>
                        <MenuList>
                            <MenuItem onClick={() => { navigate("/profile") }}>My Account</MenuItem>
                            <MenuItem onClick={() => { window.open(AppConsts.UrlSupportTeam) }}>Support</MenuItem>
                            <MenuDivider />
                            <MenuItem>
                                <Link href={"/logout"}>Logout</Link>
                            </MenuItem>
                        </MenuList>
                    </Menu>
                </Stack>
                <Box>
                    <Flex
                        flex={{ base: 1, md: 'auto' }}
                        display={{ base: 'flex', md: 'none' }}
                        placeItems={"end"}
                    >
                        <IconButton
                            onClick={onToggle}
                            icon={
                                <Avatar
                                    size={'sm'}
                                    src={user?.profilePictureFullUrl || ''}
                                />
                            }
                            variant={'ghost'}
                            aria-label={'Open menu'}
                        />
                    </Flex>
                </Box>

            </Flex>

            <Drawer
                isOpen={isOpen}
                placement='right'
                onClose={onToggle}
                size={"full"}
                trapFocus={false}
                blockScrollOnMount={false}
                variant={'alwaysOpen'}
            >
                {/*<DrawerOverlay />*/}
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader></DrawerHeader>

                    <DrawerBody>
                        <MobileNav user={user} />
                    </DrawerBody>

                </DrawerContent>
            </Drawer>
            {/*<Collapse in={isOpen} animateOpacity>*/}
            {/*    <MobileNav />*/}
            {/*</Collapse>*/}
        </Box>
    );
}

const DesktopNav = ({ user }: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('teal.500', 'white');
    const popoverContentBgColor = useColorModeValue('white', 'gray.800');

    return (
        <Stack direction={'row'} spacing={4}>
            {NAV_ITEMS.map((navItem) => {
                if (navItem.adminRight && user && !user.isAdmin)
                    return <></>;
                return <Box key={navItem.label}>
                    <Popover trigger={'hover'} placement={'bottom-start'}>
                        <PopoverTrigger>
                            <Link
                                p={2}
                                href={navItem.href ?? '#'}
                                onClick={(e) => { e.preventDefault(); navItem.href && navigate(navItem.href); }}
                                fontSize={'sm'}
                                fontWeight={location.pathname == navItem.href ? 'bold' : '700'}
                                color={location.pathname == navItem.href ? linkHoverColor : linkColor}
                                _hover={{
                                    textDecoration: 'none',
                                    color: linkHoverColor,
                                }}>
                                {navItem.label}
                            </Link>
                        </PopoverTrigger>

                        {navItem.children && (
                            <PopoverContent
                                border={0}
                                boxShadow={'xl'}
                                bg={popoverContentBgColor}
                                p={4}
                                rounded={'xl'}
                                minW={'sm'}>
                                <Stack>
                                    {navItem.children.map((child) => (
                                        <DesktopSubNav key={child.label} {...child} />
                                    ))}
                                </Stack>
                            </PopoverContent>
                        )}
                    </Popover>
                </Box>
            }
            )}
        </Stack>
    );
};

const DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
    const navigate = useNavigate();
    return (
        <Link
            //href={href}
            onClick={() => { href && navigate(href) }}
            role={'group'}
            display={'block'}
            p={2}
            rounded={'md'}
            _hover={{ bg: useColorModeValue('primary.50', 'gray.900') }}>
            <Stack direction={'row'} align={'center'}>
                <Box>
                    <Text
                        transition={'all .3s ease'}
                        _groupHover={{ color: 'primary.400' }}
                        fontWeight={500}>
                        {label}
                    </Text>
                    <Text fontSize={'sm'}>{subLabel}</Text>
                </Box>
                <Flex
                    transition={'all .3s ease'}
                    transform={'translateX(-10px)'}
                    opacity={0}
                    _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
                    justify={'flex-end'}
                    align={'center'}
                    flex={1}>
                    <Icon color={'primary.400'} w={5} h={5} as={ChevronRightIcon} />
                </Flex>
            </Stack>
        </Link>
    );
};

const Logo = (props: any) => {
    return (
        <img {...props} width={'128px'} viewBox="0 0 120 28" src={process.env.PUBLIC_URL + AppConsts.LOGO_PATH} alt={AppConsts.APP_NAME} />
    );
};

const MobileNav = ({ user }: any) => {
    const navigate = useNavigate();

    return (
        <Stack
            bg={useColorModeValue('white', 'gray.800')}
            p={4}
            display={{ md: 'none' }}>

            <Box borderWidth={'1px'} rounded={'lg'} p={5}>
                <Center>
                    <Avatar
                        showBorder={true}
                        size={'xl'}
                        src={user?.profilePictureFullUrl || ''}
                    />
                </Center>
                <Center mt={1} fontWeight={600}>
                    <p>{user.name}</p>

                </Center>
                <Center>
                    <Link variant={'Invert'} onClick={() => navigate('/profile')}>Profil Anda</Link>
                </Center>
            </Box>

            {NAV_ITEMS.map((navItem) => {
                if (navItem.adminRight && user && !user.isAdmin)
                    return <></>;

                return <MobileNavItem key={navItem.label} {...navItem} />
            }
            )}
            <MobileNavItem label={'Log Out'} href={'/logout'} />
        </Stack>
    );
};

const MobileNavItem = ({ label, children, href }: NavItem) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isOpen, onToggle } = useDisclosure();
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('teal.500', 'white');

    return (
        <Stack spacing={4} onClick={children && onToggle}>
            <Flex
                py={2}
                as={Link}
                //href={href ?? '#'}
                onClick={() => { href && navigate(href) }}
                justify={'space-between'}
                align={'center'}
                borderBottom={'1px'}
                borderColor={'gray.100'}
                _hover={{
                    textDecoration: 'none'
                }}
            >
                <Text
                    color={location.pathname == href ? linkHoverColor : linkColor}
                    fontWeight={location.pathname == href ? 'bold' : '500'}
                    variant={"MenuItem"}
                    whiteSpace={"nowrap"} >
                    {label}
                </Text>
                {children && (
                    <Icon
                        as={ChevronDownIcon}
                        transition={'all .25s ease-in-out'}
                        transform={isOpen ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                    />
                )}
            </Flex>

            <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
                <Stack
                    mt={2}
                    pl={4}
                    borderLeft={1}
                    borderStyle={'solid'}
                    borderColor={useColorModeValue('gray.200', 'gray.700')}
                    align={'start'}>
                    {children &&
                        children.map((child) => (
                            <Link key={child.label} py={2} href={child.href}>
                                {child.label}
                            </Link>
                        ))}
                </Stack>
            </Collapse>
        </Stack>
    );
};

interface NavItem {
    label: string;
    subLabel?: string;
    children?: Array<NavItem>;
    adminRight?: boolean;
    href?: string;
}

const NAV_ITEMS: Array<NavItem> = [
    {
        label: 'Dashboard',
        href: '/dashboard',
        adminRight: true
    },
    {
        label: 'Order',
        href: '/orders',
        adminRight: true
    },
    {
        label: 'Members',
        href: '/members',
        adminRight: true
    },
    {
        label: 'Programs',
        href: '/programs',
    },
    {
        label: 'Voucher',
        href: '/vouchers',
    },
    {
        label: 'Short Urls',
        href: '/shorturls',
    },
    {
        label: 'Settings',
        children: [{
            label: 'Banner',
            href: '/banners',
        }, {
            label: 'Author',
            href: '/authors',
        }]
    },
    //{
    //    label: 'Mitra',
    //    children: [
    //        {
    //            label: 'Mitra',
    //            subLabel: `Daftar Mitra ${AppConsts.APP_NAME}`,
    //            href: '/partners'
    //        },
    //        {
    //            label: 'Penarikan Dana',
    //            subLabel: 'Permintaan Penarikan Dana',
    //            href: '/partners/request'
    //        }
    //    ]
    //},
    //{
    //    label: 'Master Data',
    //    children: [
    //        {
    //            label: 'Produk',
    //            subLabel: 'Produk Store',
    //            href: '/products'
    //        }
    //    ]
    //}
];

if (AppConsts.ENABLE_MODULE_PARTNER) {
    NAV_ITEMS.push(
        {
            label: 'Mitra',
            children: [
                {
                    label: 'Mitra',
                    subLabel: `Daftar Mitra ${AppConsts.APP_NAME}`,
                    href: '/partners'
                },
                {
                    label: 'Penarikan Dana',
                    subLabel: 'Permintaan Penarikan Dana',
                    href: '/partners/request'
                }
            ]
        });
}

if (AppConsts.ENABLE_STORE) {
    NAV_ITEMS.push(
        {
            label: 'Store Order',
            href: '/storeorders',
        });
}

const Layout: FC<LayoutProps> = ({ children }) => {
    const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());

    return (
        <Box as="header">
            <Container maxWidth={"8xl"} pl={0} pr={0}>
                <WithSubnavigation />
            </Container>
            <Box as="main" minHeight={'80vh'} mb={10}>
                {children}
            </Box>
            <Box
                bg={useColorModeValue('gray.50', 'gray.900')}
                color={useColorModeValue('gray.700', 'gray.200')}>
                <Box py={10}>
                    <Flex
                        align={'center'}
                        _before={{
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: useColorModeValue('gray.200', 'gray.700'),
                            flexGrow: 1,
                            mr: 8,
                        }}
                        _after={{
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: useColorModeValue('gray.200', 'gray.700'),
                            flexGrow: 1,
                            ml: 8,
                        }}>
                        <Logo />
                    </Flex>
                    <Text pt={6} fontSize={'sm'} textAlign={'center'}>
                        © {currentYear} {AppConsts.APP_NAME}. All rights reserved
                    </Text>
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;